"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * The options menu item component which should be used
 * as direct children of the <OptionsMenu /> component.
 *
 * NOTE: This is a dummy component in which props are
 * actually set within the <OptionsMenu /> component
 * (See src/lib/components/OptionsMenu/index.js for details)
 */
var OptionsMenuItem = function OptionsMenuItem(props) {
  return _react["default"].createElement("div", props);
};

var _default = OptionsMenuItem;
exports["default"] = _default;